module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/custom-domain-redirect/custom-domain-redirect.component.scss
// module id = ./src/app/custom-domain-redirect/custom-domain-redirect.component.scss
// module chunks = main